import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import BackgroundVideo from "../components/Background-Video";
import BackButton from "../partials/Back-Button";
import { motion } from "framer-motion";
import Videos from "../video/101160_SCS_Interactive_Sc5_4K_10s_V4.mp4";

const EdgeManufacturing = () => {
  const [activeDot, setActiveDot] = useState("");
  const [dotOneX, setDotOneX] = useState();
  const [dotOneY, setDotOneY] = useState();
  const [blobOneX, setBlobOneX] = useState();
  const [blobOneY, setBlobOneY] = useState();
  const [dotTwoX, setDotTwoX] = useState();
  const [dotTwoY, setDotTwoY] = useState();
  const [blobTwoX, setBlobTwoX] = useState();
  const [blobTwoY, setBlobTwoY] = useState();
  const [dotThreeX, setDotThreeX] = useState();
  const [dotThreeY, setDotThreeY] = useState();
  const [blobThreeX, setBlobThreeX] = useState();
  const [blobThreeY, setBlobThreeY] = useState();

  const dotOne = useRef();
  const dotTwo = useRef();
  const dotThree = useRef();
  const blobOne = useRef();
  const blobTwo = useRef();
  const blobThree = useRef();

  const getPosition = () => {
    const dotOne = document.getElementById("dotOne").getBoundingClientRect();
    const dotOneTop = dotOne.top;
    const dotOneLeft = dotOne.left;

    setDotOneX(dotOneLeft + 21.5);
    setDotOneY(dotOneTop + 21.5);

    const blobOne = document.getElementById("blobOne").getBoundingClientRect();
    const blobOneTop = blobOne.top;
    const blobOneLeft = blobOne.left;

    setBlobOneX(blobOneLeft);
    setBlobOneY(blobOneTop);

    const dotTwo = document.getElementById("dotTwo").getBoundingClientRect();
    const dotTwoTop = dotTwo.top;
    const dotTwoLeft = dotTwo.left;

    setDotTwoX(dotTwoLeft + 21.5);
    setDotTwoY(dotTwoTop + 21.5);

    const blobTwo = document.getElementById("blobTwo").getBoundingClientRect();
    const blobTwoTop = blobTwo.top;
    const blobTwoLeft = blobTwo.left;

    setBlobTwoX(blobTwoLeft);
    setBlobTwoY(blobTwoTop);

    const dotThree = document
        .getElementById("dotThree")
        .getBoundingClientRect();
    const dotThreeTop = dotThree.top;
    const dotThreeLeft = dotThree.left;

    setDotThreeX(dotThreeLeft + 21.5);
    setDotThreeY(dotThreeTop + 21.5);

    const blobThree = document
        .getElementById("blobThree")
        .getBoundingClientRect();
    const blobThreeTop = blobThree.top;
    const blobThreeLeft = blobThree.left;

    setBlobThreeX(blobThreeLeft);
    setBlobThreeY(blobThreeTop);
  };

  useEffect(() => {
    getPosition();
  }, []);

  return (
      <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="w-screen h-[calc(100vh-120px)] 2xl:h-[calc(100vh-172px)] relative top-[120px] 2xl:top-[172px] left-0"
      >
        <BackButton backurl="/edge-compute" />
        <BackgroundVideo fullscreen video={Videos} />

        <div className="w-screen h-[calc(100vh-120px)] 2xl:h-[calc(100vh-172px)] relative">
          <div className=" bg-opacity-40 backdrop-blur-sm bg-white w-[393px] 2xl:w-[646px] left-[90px] -top-[5px] py-7 px-9 2xl:py-14 2xl:pl-[59px] 2xl:pr-[45px] rounded-3xl relative left-10 top-5 zoom-8">
            <h1 className="font-semibold uppercase text-dell-blue font-proxima-nova text-lg 2xl:text-[25px] 2xl:leading-[30px] pb-3">
              Manufacturing
            </h1>
            <p className=" text-[#444444] text-xl 2xl:text-[30px] 2xl:leading-[37px] font-proxima-nova font-thin">
              Gain access to the edge and enterprise data center spend by boosting 5G adoption in the manufacturing industry with scalable and easy-to-manage edge solutions.
            </p>
          </div>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 1 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotOneX}
                y1={dotOneY}
                x2={blobOneX}
                y2={blobOneY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 2 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotTwoX}
                y1={dotTwoY}
                x2={blobTwoX}
                y2={blobTwoY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 3 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotThreeX}
                y1={dotThreeY}
                x2={blobThreeX}
                y2={blobThreeY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <div className="edge-dots absolute w-screen h-[calc(100vh-172px)] top-0 grid grid-cols-5 grid-rows-3">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>

            <div className="relative flex pl-[30%] items-center align-middle justify-center">
              <div
                  ref={dotOne}
                  id="dotOne"
                  className="dot-one dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#6E2585] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(1)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(1)}
                  onKeyDown={() => setActiveDot("")}
                  tabindex="0"
              ></div>

              <div
                  ref={blobOne}
                  id="blobOne"
                  className={classnames(
                      "blob-one absolute left-[75%] 2xl:left-full 2xl:bottom-0 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-white min-w-[443px] h-[443px] transition-all duration-300 ",
                      activeDot === 1
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Worker Safety Monitoring:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Hazards and PPE faults can be <br />
                  identified proactively, maximizing
                  <br />
                  worker safety with video surveillance.
                  <br />
                  <br />
                  Neuro-haptic sensors can increase <br />
                  worker safety in noisy environments <br />
                  helping to prevent injuries and <br />
                  reduce insurance costs.
                </p>
              </div>
            </div>
            <div></div>
            <div className="relative flex justify-center pt-9">
              <div
                  ref={dotTwo}
                  id="dotTwo"
                  className="left-[50%] dot-two dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] bg-[#6E2585] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(2)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(2)}
                  onKeyDown={() => setActiveDot("")}
                  tabindex="0"
              ></div>

              <div
                  ref={blobTwo}
                  id="blobTwo"
                  className={classnames(
                      "blob-two absolute left-[50%] 2xl:left-[65%] bottom-0 2xl:bottom-1/2 px-10 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-white min-w-[391px] h-[391px] transition-all duration-300",
                      activeDot === 2
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Quality Control:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Products scanned for <br />
                  anomalies using computer <br />
                  vision help ensure higher <br />
                  quality and waste reduction.
                  <br />
                  <br />
                  Scanning technology results in <br />
                  faster and more efficient
                  <br />
                  reconfiguration of the <br />
                  production floor.
                </p>
              </div>

              <div
                  ref={blobThree}
                  id="blobThree"
                  className={classnames(
                      "blob-three absolute left-[35%] bottom-0 2xl:left-[50%] 2xl:bottom-10 p-10 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-white min-w-[454px] h-[454px] transition-all duration-300",
                      activeDot === 3
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Proactive Maintenance <br />& Design Testing:
                </p>
                <p className="text-xl font-proxima-nova font-thin leading-6">
                  Use of AR (augmented reality) allows <br />
                  for real-time collaboration, enabling <br />
                  proactive maintenance and reducing
                  <br />
                  incident response time.
                  <br />
                  <br />
                  Digital twins provide the ability for <br />
                  product designers to glean insights <br />
                  from production data, which can <br />
                  result in greater efficiencies and <br />
                  cost-savings.
                </p>
              </div>
            </div>
            <div className="relative flex justify-end">
              <div
                  ref={dotThree}
                  id="dotThree"
                  className="dot-three dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px] top-[10%] bg-[#6E2585] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(3)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(3)}
                  onKeyDown={() => setActiveDot("")}
                  tabindex="0"
              ></div>
            </div>
            <div></div>

            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </motion.div>
  );
};

export default EdgeManufacturing;
